import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAGS_FORMULAREN, KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { addIndexesToPath } from 'src/utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureAntragFinanzierungsPlanGlobal } from '../../global-structure/finanzierung-plan-antrag/TreeStructureAntragFinanzierungsPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVerbundpartnerGlobal } from '../../global-structure/verbundpartner-antrag/TreeStructureAntragVerbundpartnerGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import EinnahmeUebersichtAntragEmob from './content/Eigenmittel/EinnahmeUebersichtAntragEmob';
import { GetEigenmittelAntragEmobFundE } from './content/Eigenmittel/emob_funde/GetEigenmittelAntragEmob';
import EigenmittelAntragEmob, { getFormStrucEigenmittelAntragEmob } from './content/Eigenmittel/emob_invest/EigenmittelAntragEmob';
import EigenmittelAntragEmobLis, { getFormStrucEigenmittelAntragEmobLis } from './content/Eigenmittel/emob_lis/EigenmittelAntragEmobLis';
import { GetInvestitionkostenAntragEmobLis } from './content/Investitionkosten/emob-lis/GetInvestitionkostenAntragEmob';
import InvestitionsUebersichtAntragEmobLIS from './content/Investitionkosten/emob-lis/InvestitionsUebersichtAntragEmonLIS';
import InvestitionkostenAntragEmob, {
	getFormStrucInvestitionkostenAntragEmob,
} from './content/Investitionkosten/emob_invest/InvestitionkostenAntragEmob';
import InvestitionsUebersichtAntragEmob from './content/Investitionkosten/InvestitionsUebersichtAntragEmob';
import { GetPersonalKostenAntragEmob } from './content/Personalkosten/GetPersonalKostenAntragEmob';
import PersonalKostenUebersichtAntragEmob from './content/Personalkosten/PersonalKostenUebersichtAntragEmob';
import AusgangssituationForschungAntragEmonbFundE, {
	getFormStrucAusgangssituationForschungAntragEmonbFundE,
} from './content/Projektbeschreibung/emob-forschung/AusgangssituationForschungAntragEmonbFundE';
import BeschreibungVorhabensForschungAntragEmobFundE, {
	getFormStrucBeschreibungVorhabensForschungAntragEmobFundE,
} from './content/Projektbeschreibung/emob-forschung/BeschreibungVorhabensForschungAntragEmobFundE';
import MarktausblickForschungAntragEmobFundE, {
	getFormStrucMarktausblickForschungAntragEmobFundE,
} from './content/Projektbeschreibung/emob-forschung/MarktausblickForschungAntragEmobFundE';
import SwotAntragEmobFundE, { getFormStrucSwotAntragEmobFundE } from './content/Projektbeschreibung/emob-forschung/SwotAntragEmobFundE';
import AusgangssituationAntragEmobInvest, {
	getFormStrucAusgangssituationAntragEmobInvest,
} from './content/Projektbeschreibung/emob-investiv/AusgangssituationAntragEmobInvest';
import AusschreibungVergabeAntragEmobInvest, {
	getFormStrucAusschreibungVergabeAntragEmobInvest,
} from './content/Projektbeschreibung/emob-investiv/AusschreibungVergabeAntragEmobInvest';
import SonstigeInformationAntragEmobInvest, {
	getFormStrucSonstigeInformationAntragEmobInvest,
} from './content/Projektbeschreibung/emob-investiv/SonstigeInformationAntragEmobInvest';
import TechnischespezifikationElektrofahrzeugAntragEmobInvest, {
	getFormStrucTechnischespezifikationElektrofahrzeugAntragEmobInvest,
} from './content/Projektbeschreibung/emob-investiv/TechnischespezifikationElektrofahrzeugAntragEmobInvest';
import TechnischespezifikationLadeinfrastrukturAntragEmobInvest, {
	getFormStrucTechnischespezifikationLadeinfrastrukturAntragEmobInvest,
} from './content/Projektbeschreibung/emob-investiv/TechnischespezifikationLadeinfrastrukturAntragEmobInvest';
import WasserstoffBetankungsanlageAntragEmobInvest, {
	getFormStrucWasserstoffBetankungsanlageAntragEmobInvest,
} from './content/Projektbeschreibung/emob-investiv/WasserstoffBetankungsanlageAntragEmobInvest';
import AusgangssituationEmobLis, { getFormStrucAusgangssituationEmobLis } from './content/Projektbeschreibung/emob-lis/AusgangssituationEmobLis';
import FoerdervoraussetzungenEmobLis, {
	getFormStrucFoerdervoraussetzungenEmobLis,
} from './content/Projektbeschreibung/emob-lis/FoerdervoraussetzungenEmobLis';
import SonstigeInformationEmobLis, {
	getFormStrucSonstigeInformationEmobLis,
} from './content/Projektbeschreibung/emob-lis/SonstigeInformationEmobLis';
import StandorteEmobLis, { getFormStrucStandorteEmobLis } from './content/Projektbeschreibung/emob-lis/StandorteEmobLis';
import ProjektdatenAntragEmob, { getFormStrucProjektdatenAntragEmob } from './content/ProjektdatenAntragEmob';
import { GetSachkostenAntragEmob } from './content/Sachkosten/GetSachkostenAntragEmob';
import SachkostenUebersichtAntragEmob from './content/Sachkosten/SachkostenUebersichtAntragEmob';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureAntragEmob = (
	application: any,
	kostenKategories: any,
	readOnly: boolean,
	kostenKategoriesGroup: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemein Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Fördervoraussetzung (NUR LIS)
		...FoerdervoraussetzungEmobLis(application, readOnly),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektdatenAntragEmob hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektdatenAntragEmob(application),
			showError: false,
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Verbundpartner Global
		...TreeStructureAntragVerbundpartnerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Projektbeschreibung
		...ProjektBeschreibungStructure(application, readOnly),
		// Kosten
		...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...InvestitionsKostenStructure(application, kostenKategories, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EigenUndDrittMittelStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...TreeStructureAntragFinanzierungsPlanGlobal(application, isKostenEditable),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erklärungen  Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const FoerdervoraussetzungEmobLis = (application: any, readOnly: boolean) => {
	const antragsFormular = get(application, P.Allgemein_Antragsformular.path);

	if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
		const hasCommentFoerdervoraussetzungen = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0148514099_tzungen_Pruefung_Pruefstatus.path,
		);
		return [
			{
				label: 'Fördervoraussetzungen',
				content: <FoerdervoraussetzungenEmobLis hasComment={hasCommentFoerdervoraussetzungen} />,
				hasComment: hasCommentFoerdervoraussetzungen,
				formStruc: getFormStrucFoerdervoraussetzungenEmobLis(application),
			},
		];
	}
	return [];
};

const ProjektBeschreibungStructure = (application: any, readOnly: boolean) => {
	const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');

	if (antragsFormular === ANTRAGS_FORMULAREN.EmobInvest) {
		const hasCommentAusgangssituation = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109726323_tuation_Pruefung_Pruefstatus.path,
		);
		const hasCommentTechnischeSpezifikationElektrofahrzeug = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0097856355_ahrzeug_Pruefung_Pruefstatus.path,
		);
		const hasCommentTechnischeSpezifikationLadeinfrastruktur = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0035907651_truktur_Pruefung_Pruefstatus.path,
		);
		const hasCommentWasserstoffBetankungsanlage = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0235756515_sanlage_Pruefung_Pruefstatus.path,
		);
		const hasCommentAusschreibungVergabe = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0068448995_Vergabe_Pruefung_Pruefstatus.path,
		);
		const hasCommentSonstigeInformation = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0167902019_ationen_Pruefung_Pruefstatus.path,
		);
		return [
			{
				label: 'Projektbeschreibung',
				content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
				hasComment:
					hasCommentAusgangssituation ||
					hasCommentTechnischeSpezifikationElektrofahrzeug ||
					hasCommentTechnischeSpezifikationLadeinfrastruktur ||
					hasCommentWasserstoffBetankungsanlage ||
					hasCommentAusschreibungVergabe ||
					hasCommentSonstigeInformation,
				children: [
					{
						label: 'Ausgangssituation',
						content: <AusgangssituationAntragEmobInvest hasComment={hasCommentAusgangssituation} />,
						hasComment: hasCommentAusgangssituation,
						formStruc: getFormStrucAusgangssituationAntragEmobInvest(application),
					},
					{
						label: 'Technische Spezifikationen Elektrofahrzeug',
						content: <TechnischespezifikationElektrofahrzeugAntragEmobInvest hasComment={hasCommentTechnischeSpezifikationElektrofahrzeug} />,
						hasComment: hasCommentTechnischeSpezifikationElektrofahrzeug,
						formStruc: getFormStrucTechnischespezifikationElektrofahrzeugAntragEmobInvest(application),
					},
					{
						label: 'Technische Spezifikationen Ladeinfrastruktur',
						content: (
							<TechnischespezifikationLadeinfrastrukturAntragEmobInvest hasComment={hasCommentTechnischeSpezifikationLadeinfrastruktur} />
						),
						hasComment: hasCommentTechnischeSpezifikationLadeinfrastruktur,
						formStruc: getFormStrucTechnischespezifikationLadeinfrastrukturAntragEmobInvest(application),
					},
					{
						label: 'Wasserstoff-Betankungsanlage',
						content: <WasserstoffBetankungsanlageAntragEmobInvest hasComment={hasCommentWasserstoffBetankungsanlage} />,
						hasComment: hasCommentWasserstoffBetankungsanlage,
						formStruc: getFormStrucWasserstoffBetankungsanlageAntragEmobInvest(application),
					},
					{
						label: 'Ausschreibung und Vergabe',
						content: <AusschreibungVergabeAntragEmobInvest hasComment={hasCommentAusschreibungVergabe} />,
						hasComment: hasCommentAusschreibungVergabe,
						formStruc: getFormStrucAusschreibungVergabeAntragEmobInvest(application),
					},
					{
						label: 'Sonstige Informationen',
						content: <SonstigeInformationAntragEmobInvest hasComment={hasCommentSonstigeInformation} />,
						hasComment: hasCommentSonstigeInformation,
						formStruc: getFormStrucSonstigeInformationAntragEmobInvest(application),
					},
				],
			},
		];
	}
	if (antragsFormular === ANTRAGS_FORMULAREN.EmobFundE) {
		const hasCommentAusgangssituationForschung = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0213069123_tuation_Pruefung_Pruefstatus.path,
		);
		const hasCommentBeschreibungVorhabens = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path,
		);

		const hasCommentMarktausblick = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0149595523_wertung_Pruefung_Pruefstatus.path,
		);
		const hasCommentSwot = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0260019443_erungen_Pruefung_Pruefstatus.path,
		);
		return [
			{
				label: 'Projektbeschreibung',
				content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
				hasComment: hasCommentAusgangssituationForschung || hasCommentBeschreibungVorhabens || hasCommentMarktausblick || hasCommentSwot,
				children: [
					{
						label: 'Ausgangssituation',
						content: <AusgangssituationForschungAntragEmonbFundE hasComment={hasCommentAusgangssituationForschung} />,
						hasComment: hasCommentAusgangssituationForschung,
						formStruc: getFormStrucAusgangssituationForschungAntragEmonbFundE(application),
					},
					{
						label: 'Beschreibung des Vorhabens',
						content: <BeschreibungVorhabensForschungAntragEmobFundE hasComment={hasCommentBeschreibungVorhabens} />,
						hasComment: hasCommentBeschreibungVorhabens,
						formStruc: getFormStrucBeschreibungVorhabensForschungAntragEmobFundE(application),
					},
					{
						label: 'Marktausblick und Verwertung',
						content: <MarktausblickForschungAntragEmobFundE hasComment={hasCommentMarktausblick} />,
						hasComment: hasCommentMarktausblick,
						formStruc: getFormStrucMarktausblickForschungAntragEmobFundE(application),
					},
					{
						label: 'SWOT',
						content: <SwotAntragEmobFundE hasComment={hasCommentSwot} />,
						hasComment: hasCommentSwot,
						formStruc: getFormStrucSwotAntragEmobFundE(application),
					},
				],
			},
		];
	}
	if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
		const hasCommentAusgangssituationEmobLis = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0030170675_tuation_Pruefung_Pruefstatus.path,
		);
		const hasCommentSonstigeInformationEmobLis = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0239910483_ationen_Pruefung_Pruefstatus.path,
		);
		return [
			{
				label: 'Projektbeschreibung',
				content: <ApplicationHeading title='Projektbeschreibung' />,
				hasComment: hasCommentAusgangssituationEmobLis || hasCommentSonstigeInformationEmobLis,
				children: [
					{
						label: 'Ausgangssituation',
						content: <AusgangssituationEmobLis hasComment={hasCommentAusgangssituationEmobLis} />,
						hasComment: hasCommentAusgangssituationEmobLis,
						formStruc: getFormStrucAusgangssituationEmobLis(application),
					},
					// Standorte Dynamisch
					...get(
						application,
						P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
						[],
					).map((ele: any, i: number) => {
						const hasCommentStandorte = checkIfHasComment(
							readOnly,
							application,
							addIndexesToPath(
								P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
									.Projektbeschreibung_Elek_0211814995_truktur_Pruefung_Pruefstatus.path,
								[`${i}`],
								['Standort_Spezifikation_Ladeinfrastruktur'],
							),
						);
						return {
							label: get(ele, 'Strasse_Und_Hausnummer', `Standort ${i + 1}`),
							content: <StandorteEmobLis groupId={get(ele, 'Group_45_ID')} hasComment={hasCommentStandorte} />,
							hasComment: hasCommentStandorte,
							formStruc: getFormStrucStandorteEmobLis(application, get(ele, 'Group_45_ID')),
						};
					}),
					{
						label: 'Sonstige Informationen',
						content: <SonstigeInformationEmobLis hasComment={hasCommentSonstigeInformationEmobLis} />,
						hasComment: hasCommentSonstigeInformationEmobLis,
						formStruc: getFormStrucSonstigeInformationEmobLis(application),
					},
				],
			},
		];
	}

	return [];
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		return [
			{
				label: 'Personalkosten',
				content: <ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				children: GetPersonalKostenAntragEmob(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Personalkosten Übersicht',
				content: <PersonalKostenUebersichtAntragEmob />,
				isSummaryReport: true,
			},
		];
	}

	return [];
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		return [
			{
				label: 'Sachausgaben',
				content: <ApplicationHeading title='Sachausgaben' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				children: GetSachkostenAntragEmob(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Sachausgaben Übersicht',
				content: <SachkostenUebersichtAntragEmob />,
				isSummaryReport: true,
			},
		];
	}

	return [];
};
const InvestitionsKostenStructure = (
	application: any,
	kostenKategories: any,
	kostenKategoriesGroup: any,
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung?: boolean,
) => {
	let treeStructure: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Investitionskosten)) {
		const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');

		if (antragsFormular === ANTRAGS_FORMULAREN.EmobInvest) {
			treeStructure = [
				{
					label: 'Investitionskosten',
					content: (
						<InvestitionkostenAntragEmob
							kostentraeger='Antragsteller'
							unternehmenId={get(getLocalstorageToken(), 'organisationId')}
							hasComment={hasCommentAusgabenUndFinanzierung}
						/>
					),
					hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Investitionskosten),
					formStruc: getFormStrucInvestitionkostenAntragEmob(application, get(getLocalstorageToken(), 'organisationId'), kostenKategories),
				},
				{
					label: 'Investitionskosten Übersicht',
					content: <InvestitionsUebersichtAntragEmob />,
					isSummaryReport: true,
				},
			];
		}

		if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
			treeStructure = [
				{
					label: 'Investitionskosten',
					content: <ApplicationHeading title='Investitionskosten' description={PLATZHALTER_TEXT} />,
					hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Investitionskosten),
					children: GetInvestitionkostenAntragEmobLis(application, kostenKategories, hasCommentAusgabenUndFinanzierung),
				},
				{
					label: 'Investitionskosten Übersicht',
					content: <InvestitionsUebersichtAntragEmobLIS />,
					isSummaryReport: true,
				},
			];
		}
	}

	return treeStructure;
};
const EigenUndDrittMittelStructure = (
	application: any,
	kostenKategoriesGroup: any,
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung?: boolean,
) => {
	// autofold/fold_next

	let treeStructure: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');

		if (antragsFormular === ANTRAGS_FORMULAREN.EmobFundE) {
			treeStructure = [
				{
					label: 'Eigen- und Drittmittel',
					content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
					hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
					children: GetEigenmittelAntragEmobFundE(application, hasCommentAusgabenUndFinanzierung),
				},
				{
					label: 'Eigen- und Drittmittel Übersicht',
					content: <EinnahmeUebersichtAntragEmob />,
					isSummaryReport: true,
				},
			];
		}

		if (antragsFormular === ANTRAGS_FORMULAREN.EmobInvest) {
			treeStructure = [
				{
					label: 'Eigen- und Drittmittel',
					content: <EigenmittelAntragEmob hasComment={hasCommentAusgabenUndFinanzierung} />,
					hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
					formStruc: getFormStrucEigenmittelAntragEmob(application),
				},
				{
					label: 'Eigen- und Drittmittel Übersicht',
					content: <EinnahmeUebersichtAntragEmob />,
					isSummaryReport: true,
				},
			];
		}

		if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
			treeStructure = [
				{
					label: 'Eigen- und Drittmittel',
					content: <EigenmittelAntragEmobLis hasComment={hasCommentAusgabenUndFinanzierung} />,
					hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
					formStruc: getFormStrucEigenmittelAntragEmobLis(application),
					// children: GetEigenmittelAntragEmobLis(application),
				},
				{
					label: 'Eigen- und Drittmittel Übersicht',
					content: <EinnahmeUebersichtAntragEmob />,
					isSummaryReport: true,
				},
			];
		}
	}

	return treeStructure;
};
